import React from "react";
import { Constantes, GaUtils } from "@common/utils";
import { ChevronRight } from "@mui/icons-material";
import { UncontrolledTooltip } from "reactstrap";
import { useCurrentMenu } from "../../store/menu-app-context";

export const ButtonToUnifiedMenu = () => {
    const { setCurrentMenu } = useCurrentMenu();

    const onClick = () => {
        GaUtils.trackGAEvent(
            Constantes.GA_CATEGORY_EVENTS.CATEGORY_EVENT_NEW_UNIFIED_MENU,
            Constantes.GA_ACTION_EVENTS.EVENT_CHANGE_TO_NEW_MENU,
            Constantes.GA_LABELS_EVENTS.MENU_BAR_LEFT
        );

        setCurrentMenu("NEW");
    };

    return (
        <>
            <div
                id="ButtonToUnifiedMenu"
                className="buttonToUnifiedMenu"
                onClick={onClick}
            >
                <ChevronRight />
            </div>

            <UncontrolledTooltip
                placement="right"
                boundariesElement="window"
                delay={0}
                target={"ButtonToUnifiedMenu"}
            >
                Ir al nuevo menú
            </UncontrolledTooltip>
        </>
    );
};
